module.exports = __webpack_public_path__ + "img/34.adac7280.jpg";